import {Button, Stack, Typography, useTheme} from "@mui/material";


const Popup = ({image, title, content, onClose}) => {
    const theme = useTheme();

    return <div className="apartment-card" style={{background: theme.palette.primary[20]}}>
        <div className="apartment-card-left-column" style={{background: `url(${image})`}}/>
        <div className="apartment-card-right-column">
            <Stack spacing={1}>
                <Typography align="right" variant="headline1">{title}</Typography>
                <Typography align="justify" variant="body2" dangerouslySetInnerHTML={{ __html: content }} />
                <Button variant="outlined" onClick={onClose}>Bezárás</Button>
            </Stack>
        </div>
    </div>;
}

export default Popup